<template>
    <div class="subscription-form">
        <div class="main">
            <div v-show="purchaseOptionSelected === null">
                <div class="purchase-options-form-container">
                    <PurchaseOptionsForm
                            :showCurrency="showCurrency"
                            :selectedCountry="selectedCountry"
                            @purchaseOptionSelected="purchaseOptionSelectedHandler"
                            :purchaseOptions="purchaseOptions"
                            :code="code"
                            :referal="referal"
                    />
                </div>
            </div>
            <div v-if="purchaseOptionSelected !== null">
                <!-- Ahora va a comprar sin loguearse -->
                <Purchase
                        v-if="1 || $auth.check()"
                        :selectedCountry="selectedCountry"
                        :showCurrency="showCurrency"
                        :purchaseOption="purchaseOptionSelected"
                        @back="purchaseOptionSelected = null"
                        @loadingChange="loadingChangeHandler"
                        :code="code"
                        :referal="referal"
                />
                <template v-else>
                    <AuthenticationForm
                            :isLoginMode="false"
                            @sucessfullAuth="successfullAuthHandler"
                    />
                    <div class="buttons-container">
                        <button
                                class="back-btn"
                                type="button"
                                @click="purchaseOptionSelected = null"
                        >
                            {{$t('back')}}
                        </button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
  import Spinner from "./Spinner";
  import PurchaseOptionsForm from './SubscriptionForm.PurchaseOptionsForm';
  import AuthenticationForm from './AuthenticationForm';
  import PurchaseOptionLegals from "./PurchaseOptionLegals";
  import Purchase from './SubscriptionForm.Purchase';

  export default {
      components: {
          Spinner,
          PurchaseOptionsForm,
          Purchase,
          PurchaseOptionLegals,
          AuthenticationForm,
      },
      props: {
          code: {
              required: false,
              default: null,
          },
          referal: {
              required: false,
              default: null,
          },
          purchaseOptions: {
              required: true,
              type: Array,
          },
          selectedCountry: {
              required: true,
          },
          showCurrency: {
              required: true,
              type: Object
          },
      },
      data(){
          return {
              purchaseOptionSelected: null,
          }
      },
      mounted(){

      },
      methods: {
          loadingChangeHandler(loadingStatus){
              this.$emit('loadingChange', loadingStatus);
          },
          purchaseOptionSelectedHandler(purchaseOption){
              this.purchaseOptionSelected = purchaseOption;
          },
          successfullAuthHandler(user){
              if(this.$auth.user().membership_active){
                  this.$router.replace({name: 'dashboard'});
              }
          }
      },
      watch:{
          purchaseOptionSelected(purchaseOptionSelected){
              this.$emit('purchaseOptionSelectedChanged', purchaseOptionSelected);
          },
          purchaseOptions: {
              handler(){
                  if(this.purchaseOptions && this.purchaseOptions.length === 1){
                      //this.purchaseOptionSelected = this.purchaseOptions[0];
                  }
              },
              immediate: true,
          }
      }
  }
</script>

<style scoped lang="scss">
    @import './../styles/variables';
    @import './../styles/classes';

    .subscription-form{
    }

    .header{
        .title{
            background-color: $pallete_main_color;
            color: #ffffff;
            font-weight: bolder;
            text-transform: uppercase;
            font-size: 1.5em;
            margin: 0 0 1em 0;
            padding: 5px 1em;
            box-shadow: 1px 1px 3px rgba(0,0,0,.5);
        }
    }

    .buttons-container{
        text-align: center;

        .back-btn{
            @extend %fresh-btn;
        }
    }
</style>
